// extracted by mini-css-extract-plugin
var _1 = "webpack-system-elements-DynamicFields-RemoveFieldButton-RemoveFieldButton-module__removeFieldButton";
export { _1 as "removeFieldButton" }
